import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import MemberDetailsReportCard from "../../../admin/components/report/MemberDetailsReportCard";

const MemberDetailsReport = ({ token, client }) => {

    const history = useHistory();

    const location = useLocation();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!location.state || !client || !client.user_detail) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <MemberDetailsReportCard
                        token={token}
                        country={location.state?.country}
                        stampSetting={client.stamp}
                        tokenSetting={client.token}
                        pointSetting={client.loyalty_point}
                        userId={location.state?.userId}
                        memberId={location.state?.memberId}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

export default connect(mapStateToProps, null)(MemberDetailsReport);
